// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__vuUOr","title":"styles_title__QuHoQ","policy":"styles_policy__u+Ov2"};